import { AppThunk } from '../../../store/rootReducer';
import * as navigationActions from '../actions/navigation.actions';
import { timestampSelector } from '../selectors/navigation.selectors';

export const startNavigation = (offset: number): AppThunk => async (
  dispatch,
  getState,
) => {
  const timestamp = timestampSelector(getState());

  dispatch(
    navigationActions.start({
      offset: offset - timestamp,
      meta: { history: false },
    }),
  );
};
